<div class="tsd_container package-form-dialog">
  <mat-card-content style="text-align: end;">
    <mat-hint style="color: red;">{{showStatus}} </mat-hint>
    @if (showDeactivateToggle && id.value) {
      <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked">Deactivate Package</mat-slide-toggle>
    }
    @if (showReactivateToggle && id.value) {
      <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked">Reactivate Package</mat-slide-toggle>
    }
  </mat-card-content>
  <form [formGroup]="packageForm">
      <mat-card>
        <mat-card-content>
          <h4>{{id.value?'Edit':'Add'}} Package</h4>
          <mat-form-field class="mat-width">
            <mat-label>Package Name</mat-label>
            <input matInput formControlName="name" autocomplete="off" required>
            @if (name.touched && name.invalid && name.hasError('required')) {
              <mat-error>Package Name is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="mat-width">
            <mat-label>Package Type</mat-label>
            <mat-select formControlName="type" required>
              <mat-option [value]="null">None</mat-option>
              @for (type of packageTypes; track type) {
                <mat-option [value]="type.key">
                  {{type.label}}
                </mat-option>
              }
            </mat-select>
            @if (type.touched && type.invalid && type.hasError('required')) {
              <mat-error>Package Type is required</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="mat-width">
            <mat-label>Wooden</mat-label>
            <mat-select formControlName="wooden" required>
              @for (wooden of yesNoList; track wooden) {
                <mat-option  [value]="wooden.key">
                  {{wooden.label}}
                </mat-option>
              }
            </mat-select>
            @if (wooden.touched && wooden.invalid && wooden.hasError('required')) {
              <mat-error>Wooden Type is required</mat-error>
            }
          </mat-form-field>
          <mat-card-actions>
            <button mat-button color="cancel" (click)="cancel()">CANCEL</button>
            <button mat-button color="primary" (click)="save()" [disabled]="(status.value=='DEACTIVATED') || (!editPermission && id.value) || (!addPermission && !id.value)">SAVE</button>
          </mat-card-actions>
        </mat-card-content>
      </mat-card>
  </form>
</div>
